import React, { Component } from 'react'
import './cookie.scss'
import CookieConsent from "react-cookie-consent";

class Cookie extends Component {

    render() {
        return (
            <CookieConsent
                location="bottom"
                buttonText="That's fine"
                buttonClasses="cookie-button"
                containerClasses="cookie-consent"
                style={{ background: "rgba(30, 30, 30, 0.9)" }}
                buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
                expires={150}
                onAccept={this.props.onCookieAccepted}
            >
                This website uses cookies to enhance the user experience. <a href="privacy-policy" target="_blank">LEARN MORE</a>{" "}
            </CookieConsent>
        );
    }
}

export default Cookie;



// WEBPACK FOOTER //
// ./src/components/Cookie/Cookie.js